import React from 'react';
import Modal from '@zr/components/Modal';

import './DuplicateEmailModal.less';
import useTranslations from '@zr/i18n/useTranslations';

export const RESET_PASSWORD_URL = '/login/forgot-password?realm=candidates&set_password_prompt=1';

export const defaultStrings = {
  STRING_CTA_START: 'We\'re sending you an email you can use to verify and access your account. If you\'d like to create a password, ',
  STRING_CTA_LINK_NAME: 'create one here.',
  STRING_CLOSE: 'Close',
  STRING_DUPLICATE_ACCOUNT: ' You Already Have an Account',
  STRING_CREATE_PASSWORD: 'Create Password',
};
type translations = typeof defaultStrings;

interface DuplicateEmailModalProps {
  onCloseModal: () => void;
  strings?: Record<string, string>;
}

export const DuplicateEmailModal = ({ onCloseModal, strings }: DuplicateEmailModalProps): JSX.Element => {
  const t = useTranslations<keyof translations>({ ...defaultStrings, ...strings });
  return (
    <Modal>
      <div className="existingAccount">
        <img className="avatar" src="/img/avatar-dark.svg" width="80" height="80" alt="Avatar" />
        <h1 className="headline">{t('STRING_DUPLICATE_ACCOUNT')}</h1>

        <p className="blurb">
          {t('STRING_CTA_START')}
          <a href={RESET_PASSWORD_URL} aria-label={t('STRING_CREATE_PASSWORD')}>{t('STRING_CTA_LINK_NAME')}</a>
        </p>

        <button type="button" onClick={onCloseModal} className="close_button">{t('STRING_CLOSE')}</button>
      </div>
    </Modal>
  );
};

export default DuplicateEmailModal;
